<template>
	<div class="page">
		<van-nav-bar :title="$t('concubine.concubine')"  style="background-color: rgb(230, 41, 120)">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back(-1)" />
			</template>
		</van-nav-bar>
		<div class="box">
			<p class="name">{{ this.xuanfeidata.xuanfei_name }}</p>
			<p class="title">{{ this.xuanfeidata.vo_title }}</p>
			<van-image class="detail-image" width="98%" fit="contain" v-for="(v, k) in xuanfeidata.img_url" :key="k" :src="v" />
			<van-button round="true" @click="yuyue" class="button" color="rgb(230, 41, 120)">{{$t("foorter.subscribe")}}</van-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			xuanfeidata: []
		};
	},
	methods: {
		back() {
    // 跳转到根目录（首页）
    this.$router.push('/'); 
    
  },
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				if (res.code === 200) {
					this.xuanfeidata = {
						...res.data,
						img_url: Array.isArray(res.data.img_url) ? res.data.img_url : []
					};
				} else {
					this.$toast(res.msg);
				}
			});
		},
		yuyue() {
			this.$toast(this.$t("reservation.counselor"));
		}
	},
	created() {
		this.getxuanfeidata();
	}
};
</script>

<style>
.container {
	display: inline-block;
}
.box {
	width: 95%;
	margin: 0 auto;
	text-align: center;
	padding-bottom: 6.25rem;
}
.name {
	font-size: 1.125rem;
}
.title {
	font-size: 0.625rem;
}
.detail-image {
	display: block;
	margin: 0 auto 0.625rem;
}
.button {
	width: 10rem;
	height: 2.5rem;
	font-size: 0.9375rem;
	margin-top: 0.625rem;
}
</style>
